<template>
  <vx-card no-shadow>

    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onClickSubmit)" autocomplete="off">

        <!--        <vs-divider class="mt-8 mb-12" color="primary" position="center">Genaral Informations</vs-divider>-->


        <div class="vx-row mb-3">
          <div class="vx-col w-full md:mb-0">
            <ValidationProvider vid="is_solvents_used" name="is_solvents_used" rules="" v-slot="{ errors }">
              <small class="label">Are solvents used during the manufacturing
                process ? <br> (including extraction and process
                solvents)</small>
              <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="form.is_solvents_used" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
<!--          <div class="vx-col md:w-1/2 w-full md:mb-0">-->
<!--            <ValidationProvider v-if="form.is_solvents_used" vid="is_solvents_used_comment" name="is_solvents_used_comment" rules="required" v-slot="{ errors }">-->
<!--              <small class="label">If Yes, Give details</small>-->
<!--              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" v-model="form.is_solvents_used_comment" name="is_solvents_used_comment" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />-->
<!--            </ValidationProvider>-->
<!--          </div>-->
        </div>

        <vs-divider v-if="form.is_solvents_used" class="mt-8 mb-12" style="opacity: 0.2;" color="" position="center"/>
        <div v-if="form.is_solvents_used" v-for="(solvent, index) in form.solvent_item" :key="index" class="mt-8">

          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider  :vid="index+'identity'" :name="index+'identity'" rules="required" v-slot="{ errors }">
                <small class="label">Solvent Identity</small>
                <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" name="identity" class="w-full" v-model="solvent.identity" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider  :vid="index+'residual'" :name="index+'residual'" rules="required" v-slot="{ errors }">
                <small class="label">Residual Levels (ppm)</small>
                <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" name="residual" class="w-full" v-model="solvent.residual" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>


          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider  :vid="index+'material'" :name="index+'material'" rules="required" v-slot="{ errors }">
                <small class="label">Source Material</small>
                <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" name="material" class="w-full" v-model="solvent.material" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <vs-button :disabled="form.solvent_item.length === 1 && form.is_solvents_used" class="float-right mt-0 mb-8" @click="deleteSolvent(index)" size="small" color="danger" type="filled" icon-pack="feather" icon="icon-x">delete</vs-button>
            </div>
          </div>
          <vs-divider class="mt-4 mb-8" style="opacity: 0.2;" color="" position="center"/>
        </div>
        <vs-button v-if="form.is_solvents_used" @click="addSolvent" size="small" color="success" type="filled" icon-pack="feather" icon="icon-plus">Add solvent</vs-button>

        <div class="vx-row mb-3 mt-8">
          <div class="vx-col md:w-1/2 md:mb-0">
            <ValidationProvider vid="is_solvents_compliant" name="is_solvents_compliant" rules="" v-slot="{ errors }">
              <small class="label">Are all solvents compliant with Directive 2009/32/EC on extraction solvents used in the production of foodstuffs and food ingredients? </small>
              <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="form.is_solvents_compliant" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider v-if="form.is_solvents_compliant" vid="is_solvents_compliant_comment" name="is_solvents_compliant_comment" rules="required" v-slot="{ errors }">
              <small class="label">If Yes, Give details</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" v-model="form.is_solvents_compliant_comment" name="is_solvents_compliant_comment" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
            </ValidationProvider>
          </div>
        </div>



        <div class="flex flex-wrap items-center justify-end">
          <vs-button v-if="status.is_raw_material_solvent_complete"  button="submit" class="ml-auto mt-2" :disabled="__isDisabledRawMaterial(status)">Save Changes</vs-button>
          <vs-button v-else button="submit" class="mt-2 ml-4" :disabled="__isDisabledRawMaterial(status)">Save Changes</vs-button>
        </div>
      </form>
    </ValidationObserver>
  </vx-card>

</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  const SupplierRawMaterialRepository = RepositoryFactory.get('supplierRawMaterial')

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  export default {
    name: "SupplierManufacturingHome",
    data() {
      return {
        form: {
          solvent_item: [
            {identity: '', residual: '', material: '', function: ''}
          ],
          is_solvents_used: false,
          is_solvents_compliant: false,

        },
        id: null,
        status: {},
      }
    },
    mixins: [SuccessMessage, ErrorMessages],
    methods: {
      onClickNext() {
        this.$emit('notify', 1)
      },
      onClickSubmit() {
        this.status.is_raw_material_solvent_complete ? this.onClickUpdate() : this.onClickCreate()
      },

      async onClickUpdate() {
        this.$vs.loading()
        try {
          if (!this.form.is_solvents_used) {
            this.form.solvent_item = []
          }
          const data= (await SupplierRawMaterialRepository.UpdateRawMaterialSolvent(this.id, this.form))
          this.showSuccessMessage('Raw Material Solvent Details Updated!')
          this.onClickNext()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async onClickCreate() {
        this.$vs.loading()
        try {
          if (!this.form.is_solvents_used) {
            this.form.solvent_item = []
          }
          const data= (await SupplierRawMaterialRepository.CreateRawMaterialSolvent(this.form))
          this.showSuccessMessage('Raw Material Solvent Details Created!')
          this.onClickNext()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },

      async loadData() {
        this.$vs.loading()
        const {data} = (await SupplierRawMaterialRepository.getRawMaterialSolvent(this.id)).data
        this.form =data
        if (this.form.solvent_item.length === 0) {
          this.addSolvent()
        }
        this.$vs.loading.close()
      },
      async loadStatus() {
        this.$vs.loading()
        const {data} = (await SupplierRawMaterialRepository.getRawMaterialStatus(this.id)).data
        this.status =data
        this.$vs.loading.close()
      },
      addSolvent() {
        this.form.solvent_item.push(
          {identity: '', residual: '', material: '', function: ''}
        )
      },
      deleteSolvent(index) {
        this.form.solvent_item.splice(index, 1)
      }
    },
    async mounted() {
      this.id = this.$route.params.id
      this.form.supplier_raw_material_id =  this.id
      await this.loadStatus()
      if (this.status.is_raw_material_solvent_complete ) {
        await this.loadData()
      }
    }
  }
</script>

<style scoped>

</style>
